<template>
    <div>
        <div style="text-align: center" v-show="!!order.id">
            <b-form-group v-slot="{ ariaDescribedby }">
                <b-form-radio-group
                    id="btn-radios-2"
                    v-model="isAssignment"
                    :options="options"
                    :aria-describedby="ariaDescribedby"
                    button-variant="outline-primary"
                    name="radio-btn-outline"
                    buttons
                ></b-form-radio-group>
            </b-form-group>
        </div>

        <slot />

        <b-table striped hover :items="storedItems" :fields="fields" responsive>
            <template #cell(id)="{ item: { hash } }">
                <b-button-group size="sm">
                    <b-button
                        variant="primary"
                        v-if="hasPermissionView"
                        @click="$emit('view-item', hash)"
                        >Select</b-button
                    >
                    <b-button
                        @click="deleteItem(hash)"
                        v-if="hasPermissionDelete"
                        class="ml-2"
                        variant="warning"
                    >
                        Delete
                    </b-button>
                </b-button-group>
            </template>

            <template #cell(index)="data">
                {{ data.index + 1 }}
            </template>

            <template #cell(order_item_type_id)="data">
                {{ data.value | displayTypeName(itemTypes) }}
            </template>

            <template
                #cell(details)="{
                    item: { description, from_section, to_section, assets },
                }"
            >
                <span v-if="!!description" style="font-weight: bold">
                    {{ description }}
                </span>
                <ul class="dashed">
                    <li v-if="from_section">
                        <span style="font-weight: bold"> from: </span>
                        {{ from_section | formatLocation }}
                    </li>
                    <li v-if="to_section">
                        <span style="font-weight: bold"> to: </span>
                        {{ to_section | formatLocation }}
                    </li>
                    <li
                        v-if="assets && assets.length"
                        v-html="displayAssets(assets)"
                    ></li>
                </ul>
            </template>

            <template #cell(price)="data">
                <p class="text-right">
                    {{ data.value | currency }}
                </p>
            </template>

            <template #cell(tax)="data">
                <p class="text-right">
                    {{ calculateItemTax(data.item) | currency }}
                </p>
            </template>

            <template #cell(total)="data">
                <p class="text-right">
                    {{ calculateItemCost(data.item) | currency }}
                </p>
            </template>

            <template #cell(task_checked)="data">
                {{ data.value == 1 ? 'Yes' : 'No' }}
            </template>

            <!--   <template #bottom-row="{ fields, columns }">
                <b-td v-for="(field, i) in fields" :key="i">
                    {{ i }} {{ columns }}
                </b-td>
            </template> -->
        </b-table>
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'orders-displayItems',
    data: () => ({
        type: null,
        isAssignment: true,
    }),
    props: ['storedItems', 'customerAssets'],
    mixins: [popupMixins, permissionsMixins],
    filters: {
        displayTypeName(id, itemTypes) {
            return (itemTypes.find(x => x.id == id) || {}).name
        },

        formatLocation(s) {
            s = s || {}
            s.location = s.location || {}
            return `${s.name}, ${s.location.address1}, ${s.location.city}`
        },

        currency: num => {
            num = parseFloat(num)
            try {
                return num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
            } catch (err) {
                return '0.00'
            }
        },
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        },
    },
    computed: {
        order() {
            const order = this.$store.state.orders.item
            console.log('computed---order', order)
            return { ...(order || {}) }
        },

        itemTypes() {
            return this.$store.state.itemType.items
        },

        options() {
            return [
                { text: 'Assignment', value: true },
                { text: 'Check-Off', value: false },
            ]
        },
        fields() {
            const _fields = [
                { key: 'id', label: '', stickyColumn: true },
                { key: 'index', label: 'No' },
                { key: 'name', label: 'Name' },
                { key: 'order_item_type_id', label: 'Type' },
            ]
            const assignmentFields = [
                { key: 'details', label: 'Details' },
                { key: 'quantity', label: 'Qty' },
                { key: 'price', label: 'Price' },
                { key: 'total', label: 'Total' },
                { key: 'tax', label: 'Tax' },
            ]

            const checkOffFields = [
                { key: 'task_checked', label: 'Checked' },
                { key: 'task_value', label: 'Value' },
                { key: 'task_notes', label: 'Notes' },
            ]

            _fields.push(
                ...(this.isAssignment ? assignmentFields : checkOffFields)
            )

            return _fields
        },
    },
    watch: {
        isAssignment: function (val) {
            this.$emit('toggleAssignment', !val)
        },

        storedItems: {
            handler: function (val) {
                console.log('watched storedItems', val)
            },
            deep: true,
        },
    },
    mounted() {
        this.$nextTick().then(() => {
            this.$emit('toggleAssignment', !this.isAssignment)
        })
        console.log('mounted storedItems', this.storedItems)
    },
    methods: {
        deleteItem(hash) {
            this.$store.dispatch('orderItemStore/delete', hash)
        },

        calculateItemCost(item) {
            const type =
                this.itemTypes.find(x => item.order_item_type_id === x.id) || {}

            return (
                (type.is_discount ? -1 : 1) *
                (parseFloat(item.price) || 0) *
                (parseFloat(item.quantity) || 0)
            )
        },

        calculateItemTax(item) {
            const type =
                this.itemTypes.find(x => item.order_item_type_id === x.id) || {}

            let itemCost =
                (type.is_discount ? -1 : 1) *
                (parseFloat(item.price) || 0) *
                (parseFloat(item.quantity) || 0)
            return (itemCost * (parseFloat(item.tax_rate) || 0)) / 100
        },

        displayAssets(ids) {
            // x.name + ' ' + x.serial_no,
            const { customerAssets } = this
            console.log('displayAssets ids', ids)
            console.log('displayAssets customerAssets', ids)

            const assets = ids
                .map(id => customerAssets.find(asset => asset.id == id))
                .filter(x => !!x)

            const _html = assets.reduce((_str, asset, idx, _list) => {
                const { name, serial_no } = asset
                if (idx === 0) {
                    _str = `<b>Asset${_list.length > 0 ? 's' : ''}:</b> `
                }
                _str += `<br/>${idx + 1}&#58; ${name}${
                    serial_no ? '-' + serial_no : ''
                }`
                return _str
            }, '')
            return _html
        },
    },
}
</script>

<style scoped>
ul {
    margin: 0;
}
ul.dashed {
    list-style-type: none;
}
ul.dashed > li {
    text-indent: -30px;
}
ul.dashed > li:before {
    content: '';
    text-indent: -30px;
}
</style>
